import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Text, Flex } from 'rebass/styled-components';
import { FiPlus, FiMinus } from 'react-icons/fi';
import { Button } from '..';

const PlusIcon = styled(FiPlus)`
  stroke-width: 3px;
`;

const MinusIcon = styled(FiMinus)`
  stroke-width: 3px;
`;

function EditorButton(props) {
  const {
    variant, onClick, testid, ...otherProps
  } = props;

  return (
    <Button smallSized variant="tertiary" mt={2} mb={3} onClick={onClick} data-testid={testid}>
      <Flex alignItems="center">
        {variant === 'add' ? <PlusIcon size={12} /> : <MinusIcon size={12} />}
        <Text fontSize={0} fontWeight={500} mx={1} {...otherProps} />
      </Flex>
    </Button>
  );
}

EditorButton.defaultProps = {
  variant: 'add',
};

EditorButton.propTypes = {
  testid: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.string,
};

export default EditorButton;
